import { headerShipToAddressStyles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import { addressDrawerContainerStyles } from "@insite/content-library/Widgets/Header/AddressDrawerContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerShipToAddressStyles.drawer = {
    closeButtonProps: {
        shape: "pill",
        buttonType: "solid",
        color: "common.background",
        size: 36,
    },
    closeButtonIconProps: {
        src: "X",
        size: 24,
    },
    cssOverrides: {
        drawerContent: css`
            height: 100%;
            overflow-y: inherit;
        `,
        drawerBody: css`
            background: ${getColor("common.background")};
            height: 375px;
            overflow-x: inherit;
            overflow-y: inherit;
            top: 50%;
            transform: translateY(-50%);
            padding: 0 50px 20px 50px;
            height: auto;
            min-height: 260px;
        `,
        drawerTitle: css`
            background: ${getColor("common.background")};
        `,
    },
    headlineTypographyProps: {
        color: "text.main",
    },
};
